import { FC } from "react";
import { Select } from "antd";
import { RfxStatus } from "../../../../types/ProjectTypes";
import { rfxStatusToString } from "../ProjectStatusCell";

interface RfxStatusSelectProps {
    /** The status set on this output, if ops picked one. */
    value?: RfxStatus;
    /** The RFx status today; shown until ops pick another. */
    current?: RfxStatus;
    onChange: (status: RfxStatus) => void;
}

/**
 * Picks the RFx status for publish. The field starts on the RFx's current
 * status (in progress for a new RFx, which is what the server records when
 * none is given) and only writes to the output once ops change it.
 */
export const RfxStatusSelect: FC<RfxStatusSelectProps> = ({ value, current, onChange }) => (
    <Select
        style={{ width: "100%" }}
        value={value ?? current ?? RfxStatus.IN_PROGRESS}
        onChange={onChange}
        options={Object.values(RfxStatus).map((status) => ({
            value: status,
            label: rfxStatusToString(status),
        }))}
    />
);
